import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { StringFilterPipe } from '../../../pipes';
import { AppStateHolder } from '../../../shared';
import { UserActivitiesService } from './user-activities.service';

@Component({
    selector: 'calendar-search',
    templateUrl: 'calendar-search.component.html',
    standalone: true,
    imports: [FormsModule, StringFilterPipe, TranslateModule]
})

export class SearchCalendarComponent implements OnInit {
  appStateHolder = inject(AppStateHolder);
  private calendarService = inject(UserActivitiesService);


  calendars: any[];
  status: string = 'ok';
  term: string;

  @Output() selected: EventEmitter<any> = new EventEmitter();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
  }

  ngOnInit(): void {
    this.status = 'busy';

    this.calendarService.getCalendars()
      .subscribe(result => {
        this.calendars = result;
        this.status = 'ok';
      });
  }

  onSelectCalendar(calendar: any) {
    this.selected.next(calendar);
  }
}
